module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    style: (_vm.style)
  }, [(_vm.text) ? _c('div', {
    staticClass: "lumi-image-textbox"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-69edc73e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiImageBox.vue
// module id = 64
// module chunks = 0